import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';

import RecoverModal from '../../../components/modals/recoverModal';
import DeleteModal from '../../../components/modals/deleteModal';

import SearchFilter from '../../../components/filters/search';
import CustomButton from '../../../components/buttons/customButton';
import IsActiveFilter from '../../../components/filters/isActive';
import AddButton from '../../../components/buttons/addButton';
import DataFilter from '../../../components/filters/dataFilter';
import DatePicker from '../../../components/filters/datePicker';

import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, trailBalanceFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { Space, Input, Tag, Button, Divider, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { selectStyles } from '../../../components/dropDown/selectStyle';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';




function IncomeStatement(props) {

  let { type, isDebit } = props;

  const { api, userData, settingData, yearId, companyId, secondaryCurrency, mainCurrency, refData, branchOptions, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [selectedBranch, setSelectedBranch] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSpinning, setIsSpinning] = useState(false);
  const [currency, setCurrency] = useState('main');
  const createdBy = parseInt(userData.id);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const dataArray = ['branch']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const today = new Date().toISOString().split('T')[0];

  const [getGrossProfit, setGetGrossProfit] = useState(0);
  const [operatingExpensesArray, setOperatingExpensesArray] = useState([]);

  const [expensesBalance, setExpensesBalance] = useState(0);
  const [expensesSecondaryBalance, setExpensesSecondaryBalance] = useState(0);

  const [filter, setFilter] = useState({ search: '', companyId, yearId, fromDate: today, toDate: today });

  //change Type
  useEffect(() => {
    getIncomeStatement();
  }, [filter, selectedBranch]);

  const getIncomeStatement = async () => {
    try {
      setIsLoading(true);
      const data = {
        companyId,
        yearId,
        fromDate: filter.fromDate,
        toDate: filter.toDate,
        branchId: selectedBranch?.value,
        settingData,
      }
      let res = await api.get(`incomeStatement/getAll`, { params: data });

      if (res.data.status) {
        setGetGrossProfit(res?.data?.getGrossProfit)
        setOperatingExpensesArray(res?.data?.operatingExpensesArray)
        setExpensesBalance(res?.data?.expensesBalance)
        setExpensesSecondaryBalance(res?.data?.expensesSecondaryBalance)
      } else {
        toast.error(res?.data?.status);
      }
    } catch (error) {
      toast.error("Failed Contact Support");
    } finally {
      setIsLoading(false);
    }
  }



  return (
    <div>

      <Row className='g-2 mb-3'>

        <Col md={3}>

        </Col>

        <Col md={3}>
          <DatePicker setFilter={setFilter} filter={filter} />
        </Col>

        <Col md={2}>
          <Select
            styles={selectStyles}
            options={branchOptions}
            isSearchable={true}
            isClearable={true}
            placeholder="Select Branch"
            onChange={setSelectedBranch}
            value={selectedBranch}
            required
          />
        </Col>

        <Col md={1}>
          <Form.Select size="sm" onChange={e => setCurrency(e.target.value)} value={currency}>
            <option value={'main'}>{mainCurrency.code}</option>
            <option value={'secondary'}>{secondaryCurrency.code}</option>
          </Form.Select>
        </Col>

        <Col md={1}>
        </Col>


        <Col md={2} className="d-flex justify-content-end">
          <Button >
            <FiPrinter size={18} />
          </Button>
          <Button onClick={getIncomeStatement}>
            <FiRotateCcw size={18} />
          </Button>
        </Col>

      </Row>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>



            <Card title={contentLanguages.ProfitAndLoss} bordered={false} style={{ width: '60%' }} headStyle={{ textAlign: 'center' }}>
              <Row>
                <Col md={1}>
                </Col>
                <Col md={9}>
                  {contentLanguages.SalesRevenue}:
                </Col>
                <Col md={2}>
                  {numberFormatter(currency == 'main' ? getGrossProfit?.salesRevenue : getGrossProfit?.secondarySalesRevenue)}
                </Col>
              </Row>

              <Row>
                <Col md={1}>
                </Col>
                <Col md={9}>
                  {contentLanguages.SalesDiscounts}:
                </Col>

                <Col md={2}>
                  {numberFormatter(currency == 'main' ? getGrossProfit?.salesDiscounts : getGrossProfit?.secondarySalesDiscounts)}
                </Col>
              </Row>

              <Row>
                <Col md={1}>
                </Col>
                <Col md={9}>
                  {contentLanguages.CostOfGoodsSold}:
                </Col>

                <Col md={2}>
                  {numberFormatter(currency == 'main' ? getGrossProfit?.costOfGoodsSold : getGrossProfit?.secondaryCostOfGoodsSold)}
                </Col>
              </Row>

              <Row>
                <Col md={1}>
                </Col>
                <Col md={9}>
                  {contentLanguages.PurchaseDiscounts}:
                </Col>

                <Col md={2}>
                  {numberFormatter(currency == 'main' ? getGrossProfit?.purchaseDiscounts : getGrossProfit?.secondaryPurchaseDiscounts)}
                </Col>
              </Row>

              <Divider style={{ marginTop: 5, marginBottom: 5 }} />

              <Row className='mb-5'>
                <Col md={1}>
                </Col>
                <Col md={9} style={{ fontWeight: 'bold', color: 'green' }}>
                  {contentLanguages.GrossProfit}:
                </Col>

                <Col md={2} style={{ fontWeight: 'bold', color: 'green' }}>
                  {numberFormatter(currency == 'main' ? getGrossProfit?.grossProfit : getGrossProfit?.secondaryGrossProfit)}
                </Col>
              </Row>


              {operatingExpensesArray?.map((item, index) => (
                <Row key={index} className="mb-0">
                  <Col md={1}></Col>
                  <Col md={9}>
                    {item.name} {/* Assuming 'name' contains the account name */}
                  </Col>
                  <Col md={2}>
                    {numberFormatter(currency == 'main' ? item?.balance : item?.secondaryBalance)}
                  </Col>
                </Row>
              ))}

              <Divider style={{ marginTop: 5, marginBottom: 5 }} />

              <Row className='mb-5'>
                <Col md={1}>
                </Col>
                <Col md={9} style={{ fontWeight: 'bold', color: 'red' }}>
                  {contentLanguages.OperatingExpenses}:
                </Col>

                <Col md={2} style={{ fontWeight: 'bold', color: 'red' }}>
                  {numberFormatter(currency == 'main' ? expensesBalance : expensesSecondaryBalance)}
                </Col>
              </Row>


              <Divider />

              <Row className='mb-4'>
                <Col md={1}>
                </Col>
                <Col md={9} style={{ fontWeight: 'bold', color: 'green' }}>
                  {contentLanguages.NetIncome}:
                </Col>

                <Col md={2} style={{ fontWeight: 'bold', color: 'green' }}>
                  {numberFormatter(currency == 'main' ? getGrossProfit?.grossProfit - expensesBalance :
                    getGrossProfit?.secondaryGrossProfit - expensesSecondaryBalance)}
                </Col>
              </Row>

            </Card>




          </div>

        </div>
      }


    </div>
  )
}

export default IncomeStatement;
